import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Importação de contribuintes de IPTU via CSV (multipart).
 * POST: multipart/form-data com o arquivo CSV.
 */
@Injectable()
export class ImportarContribuintesIptuService {
  url: string = environment.BASE_URL;

  constructor(private http: HttpClient) {}

  importarArquivo(arquivo: File): Observable<any> {
    const formData = new FormData();
    // Nome da parte multipart conforme contrato do backend
    formData.append('arquivo', arquivo, arquivo.name);
    return this.http.post(`${this.url}/importacoes/contribuintes-iptu`, formData);
  }
}
